import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Family } from 'src/app/models/Family';
import { FamilyService } from 'src/app/services/family.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
declare var jQuery: any;

@Component({
  selector: 'app-family',
  templateUrl: './family.component.html',
  styleUrls: ['./family.component.scss']
})
export class FamilyComponent implements OnInit {
  titulos: String[] = ['Familia', 'Subfamilia', ''];
  options: String[] = ['Familia', 'Subfamilia'];
  listFamily: Family[] = [] ;
  filas: Family[]; 
  @ViewChild('familyModal') familyModal: ModalDirective;
  @ViewChild('deleteModal') deleteModal: ModalDirective;
  action: String;
  familyData :String;
  subFamilyData :String;
  selectEdit: String;
  indexSelect: number;
  indexRemoveSelect: number;

  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private familyService: FamilyService, private router: Router) { }

  ngOnInit() {
    this.spinner.show();
    jQuery.getScript(CONSTANTES.menu);

    this.familyService.getAll().subscribe(
      data => {
        if (getToken(data)) {
          this.init(data);
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }  
    )

    this.spinner.hide();
  }

  /**inicia los datos recuperados del servidor*/
  init(data: any){
    this.filas = data.families;
    this.listFamily = [];
    for (let i = 0; i < this.filas.length; i++) {
      if (this.filas[i].parent === null) {
        this.listFamily.push(this.filas[i]);
      }
    }
  }

  /**Método para editar los datos*/
  edit(index:number){
    this.action = "Editar";
    this.createData(index);
    this.indexSelect = index;
    this.familyModal.show();
  }

  /**Muestra el informe de */
  remove(index:number){
    this.indexRemoveSelect = index;
    this.deleteModal.show();
  }

  /**Método que se encargar de eliminar un registro*/
  delete(){
    this.spinner.show();

    this.familyService.postDelete(this.filas[this.indexRemoveSelect]).subscribe(
      data => {
        if(data.errorCode.code === "E_CLOTHES_FAMILY_ERROR"){
          this.toastr.info(data.errorCode.message, "INFO");
        }
        if (getToken(data)) {
            this.init(data);
            this.toastr.success("REGISTRO ELIMINADO CORRECTAMENTE", "INFO");  
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL BORRAR LOS DATOS", "ERROR");
      }  
    )
    this.spinner.hide();   
    this.indexRemoveSelect = null;
    this.deleteModal.hide();
  }

  /**Método para añadir registros*/
  add(){
    this.action = "Insertar";
    this.createData(0);
    this.familyModal.show();
  }

  /**Método que se encarga de crear o cargar la información en el modal para insertar o editar*/
  createData(index:number){
    this.familyData = null;
    this.subFamilyData = null;
    this.selectEdit = null;
    if(this.action === "Editar"){
      if(this.filas[index].parent===null){
        this.familyData = this.filas[index].name.toString();
        this.selectEdit = "Familia";
      }else{
        this.familyData = this.filas[index].parent.name.toString();
        this.subFamilyData = this.filas[index].name.toString();
        this.selectEdit = "Subfamilia";
      }
    }
  }

  /**Método que se encarga de insertar registros*/
  insertData(){
    if(this.action==="Insertar"){
      let insertFamily = new Family();
      if(this.selectEdit.toString() === 'Subfamilia'){
        insertFamily.name = this.subFamilyData.toString();
        for(let i = 0; i < this.listFamily.length; i++){
            if(this.familyData.toString() === this.listFamily[i].name.toString()){
              insertFamily.parent = this.listFamily[i];      
            }
        }
      }else{
        insertFamily.name = this.familyData.toString();
        insertFamily.parent = null;
      }
      this.spinner.show();

      this.familyService.postSave(insertFamily).subscribe(
        data => {
          if (getToken(data)) {
            this.init(data);
            this.closeModal();
            this.toastr.success("DATOS CORRECTAMENTE ACTUALIZADOS", "INFO");
          }
        },
        error => {
          this.spinner.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
        }  
      )

      this.spinner.hide();
    
    }else{
      let editFamily = this.filas[this.indexSelect];
      if(this.selectEdit.toString() === 'Subfamilia'){
        editFamily.name = this.subFamilyData.toString();
        for(let i = 0; i < this.listFamily.length; i++){
          if(this.familyData.toString() === this.listFamily[i].name.toString()){
            editFamily.parent = this.listFamily[i];      
          }
       }
      }else{
        editFamily.name = this.familyData.toString();
        editFamily.parent = null;
      }

      this.spinner.show();

      this.familyService.postSave(editFamily).subscribe(
        data => {
          if (getToken(data)) {
            this.init(data);
            this.closeModal();
            this.indexSelect = null; 
            this.toastr.success("DATOS ACTUALIZADOS CORRECTAMENTE", "INFO");
          }
        },
        error => {
          this.spinner.hide();
          this.toastr.error("HA OCURRIDO UN ERROR AL GUARDAR LOS DATOS", "ERROR");
        }  
      )
      this.spinner.hide();
    }

  }

  /**Método que se encarga de cerrar y liberar la memoria del modal*/
  closeModal(){
    this.familyModal.hide();
    this.familyModal.ngOnDestroy();
  }

}